import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            position: 'static',
        },
        tableContent: {
            boxShadow: 'none !important',
        },
        cardContent: {
            padding: theme.spacing(2),
        },
        addIcon: {
            cursor: 'pointer',
        },
    }
})
